import React from "react";

export default function MSAccess_Count() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Count</h1>
      <p>This is the MSAccess_Count component generated from the SQL JSON.</p>
    </div>
  );
}
